import { getTeamCourseAssignmentKey } from '../Assignments/Team/useCourseAssignmentTeamDetails';
import { getTeamCourseAssignmentsKey } from '../Assignments/Team/useTeamCourseAssignments';
import { getTeamCourseCompletionKey } from '../Assignments/Team/useTeamCourseCompletion';
import { getUserCourseAssignmentKey } from '../Assignments/User/useCourseAssignmentUserDetails';
import { getUserCourseAssignmentsKey } from '../Assignments/User/useUserCourseAssignments';
import { getUserCourseCompletionKey } from '~/pages/Courses/_shared/useUserCourseCompletion';
import { getCourseAssignmentIndividualSummariesKey } from '../Manage/People/UserSummaries/useCourseAssignmentIndividualSummaries';
import { getCourseAssignmentIndividualSummaryDetailsKey } from '../Manage/People/UserSummaries/useCourseAssignmentIndividualSummaryDetails';
import { getCourseAssignmentTeamSummariesKey } from '../Manage/People/TeamSummaries/useCourseAssignmentTeamSummaries';
import { getCourseAssignmentTeamSummaryDetailsKey } from '../Manage/People/TeamSummaries/useCourseAssignmentTeamSummaryDetails';
import { getCourseAssignmentUserCompletionKey } from '../View/[wikiid]/Assignees/useCourseAssignmentUserCompletion';
import { getCourseAssigneesKey } from './useCourseAssignees';
import { getCourseTeamAssigneesKey } from './useCourseTeamAssignees';
import { getCourseAssigneeKey } from './useCourseAssignee';

const [teamCourseAssignmentKey] = getTeamCourseAssignmentKey();
const [teamCourseAssignmentsKey] = getTeamCourseAssignmentsKey();
const [teamCourseCompletionKey] = getTeamCourseCompletionKey();
const [userCourseAssignmentKey] = getUserCourseAssignmentKey();
const [userCourseAssignmentsKey] = getUserCourseAssignmentsKey();
const [userCourseCompletionKey] = getUserCourseCompletionKey();
const [courseAssignmentIndividualSummariesKey] = getCourseAssignmentIndividualSummariesKey();
const [courseAssignmentIndividualSummaryDetailsKey] =
   getCourseAssignmentIndividualSummaryDetailsKey();
const [courseAssignmentTeamSummariesKey] = getCourseAssignmentTeamSummariesKey();
const [courseAssignmentTeamSummaryDetailsKey] = getCourseAssignmentTeamSummaryDetailsKey();
const [courseAssignmentUserCompletionKey] = getCourseAssignmentUserCompletionKey();
const [courseAssigneeKey] = getCourseAssigneeKey();
const [courseAssigneesKey] = getCourseAssigneesKey();
const [courseTeamAssigneesKey] = getCourseTeamAssigneesKey();

export function getCourseAssignmentKeys(): string[] {
   return [
      teamCourseAssignmentKey,
      teamCourseAssignmentsKey,
      teamCourseCompletionKey,
      userCourseAssignmentKey,
      userCourseAssignmentsKey,
      userCourseCompletionKey,
      courseAssignmentIndividualSummariesKey,
      courseAssignmentIndividualSummaryDetailsKey,
      courseAssignmentTeamSummariesKey,
      courseAssignmentTeamSummaryDetailsKey,
      courseAssignmentUserCompletionKey,
      courseAssigneeKey,
      courseAssigneesKey,
      courseTeamAssigneesKey,
   ];
}
